export default "__VITE_ASSET__BL$qFBos__"